<template>
  <div class="main-body">
    <div class="header">商品分类</div>
    <div class="out">

      <div class="search2">

        <el-button size="mini" type="primary" plain @click.native="toggleModalAdd">添加</el-button>

        <div style="float:right;">

          <el-select v-model="businessCode" placeholder="请选择商家" style="margin-right:5px">
            <el-option
                v-for="item in arr_business"
                :key="item.businessCode"
                :label="item.name"
                :value="item.businessCode">
            </el-option>
          </el-select>

          <el-button size="mini" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>

        </div>

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" :data="tableData" :height="th" border>

        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="sort" label="排序"></el-table-column>
        <el-table-column prop="status" label="状态" align='center'>
          <template slot-scope="scope">
            <el-tag type="success" slot="reference" v-if="scope.row.status==1">正常</el-tag>
            <el-tag type="danger" slot="reference" v-if="scope.row.status==2">禁用</el-tag>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="200" align='center'>
          <template slot-scope="scope">
            <el-button type="success" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-bind:arr_business="arr_business" v-on:closeAdd="closeAdd"  v-on:getList="getList"></Add>
    <Edit ref="myEdit" v-show="showModalEdit" v-bind:arr_business="arr_business" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getGovernmentCode, getStaffCode} from "@/utils/auth";

import Edit from "./Edit";
import Add from "./Add";

export default {
  name: "Role",
  data(){
    return{
      loading:false,

      showModalAdd:false,
      showModalEdit:false,

      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,
      th:0,


      arr_business:[],
      businessCode:'',

    }
  },
  components:{
    Add,Edit
  },
  created(){
    this.getBusiness()

    this.th = this.$store.state.tableHeight+50;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val+50;
    },
  },
  methods:{

    getBusiness(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Business/GovList",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          governmentCode: getGovernmentCode(),
          businessType:1,
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
              this.arr_business = response.data.data;
              if(this.arr_business.length>0){
                this.businessCode = this.arr_business[0].businessCode;
                this.getList();
              }

            }else if(response.data.error === 1){
              this.$message.error(response.data.message)
            }

          }
      )

    },



    toggleModalAdd:function(){
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init();
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },

    handleEdit(index, row) {
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },

    handleDelete(index,row){
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.$axios({
          method: 'post',
          url: this.$shopUrl + "GoodsClassBusiness/Delete",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            staffCode: getStaffCode(),
            goodsClassBusinessCode:row.goodsClassBusinessCode,
          }
        }).then((response) => {
          if (response.data.error == 0) {
            this.getList()
          } else if (response.data.error == 1) {
            this.$message({type: 'error', message: response.data.message});
          }
        }).catch(function (error) {
          console.log(error);
        });

      }).catch(() => {
      });
    },


    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch){
      if(isSearch)this.currentPage=1

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"GoodsClassBusiness/GovPage",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          businessCode:this.businessCode,
        }
      }).then( (response)=> {
        if(response.data.error == 0){
          this.tableData = response.data.data;
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    statusTitle(row){
      if(row.status == 1){
        return "正常";
      }
      if(row.status == 2){
        return "禁用";
      }
      return "其它";
    },



  }
}
</script>

<style lang="scss" scoped>
.goodsClass{
  /deep/ .el-table .cell .el-table__indent{
    padding-left: 50px !important;
  }
  /deep/ .el-table .success-row {
    background:#EBEEF5;
  }
}

</style>
